import React from 'react';
import { Modal, Card, CardContent, CardHeader, IconButton, Stack, Alert } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const SendMessageResultModal = ({ open, handleClose, result }) => {
  const columns = [
    { field: 'identifier', headerName: 'Numer zamówienia', flex: 1 },
    { field: 'email', headerName: 'E-mail', flex: 1 },
    { field: 'phone', headerName: 'Numer telefonu', flex: 1 },
    { field: 'name', headerName: 'Imię i nazwisko', flex: 1 }
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style, minWidth: '70vw' }}>
        <CardHeader
          title="Podsumowanie"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent style={{ height: '75vh', overflow: 'auto' }}>
          <Stack spacing={4}>
            <Alert severity="success">Wysłano: {result.send}</Alert>
            <Alert severity="warning">Pominięto: {result.skiped}</Alert>
            {result.skiped > 0
              ? <div style={{ height: 300, width: '100%' }}>
                <DataGridPro
                  rows={result.skiped_list}
                  columns={columns}
                  localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                />
              </div>
              : null}
            <Alert severity="error">Błędy (Nie udało się wysłać): {result.error}</Alert>
            {result.error > 0
              ? <div style={{ height: 300, width: '100%' }}>
                <DataGridPro
                  rows={result.error_list}
                  columns={columns}
                  localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                />
              </div>
              : null}

          </Stack>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default SendMessageResultModal;
